import * as React from "react"
import * as Yup from "yup"

import {
  ContactFromWrapper,
  ContactPageTitle,
  ContactWrapper,
  InputGroup,
} from "./style"
import { Form, Formik, FormikActions, FormikProps } from "formik"

import Button from "../../components/Button/Button"
import Input from "../../components/Input/Input"
import { navigate } from "gatsby"

interface MyFormValues {
  firstName: string
  email: string
  message: string
}

const SignupSchema = Yup.object().shape({
  firstName: Yup.string().required("Required"),
  email: Yup.string()
    .email("Invalid email")
    .required("Required"),
  message: Yup.string().required("Required"),
})

function encode(data) {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&")
}

const Contact: React.SFC<{}> = () => {
  return (
    <Formik
      initialValues={{
        "bot-field": "",
        "form-name": "contact",
        firstName: "",
        email: "",
        message: "",
      }}
      onSubmit={(
        values: MyFormValues,
        actions: FormikActions<MyFormValues>
      ) => {
        let bodyContent =
          "From: " +
          values.firstName +
          " of email " +
          values.email +
          " and he says: " +
          values.message
        fetch("/", {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: encode({
            "form-name": "formik",
            ...values,
          }),
        })
          .then(succ => navigate("/thanks"))
          .catch(error => alert(error))
      }}
      validationSchema={SignupSchema}
      render={({
        handleChange,
        values,
        errors,
        handleBlur,
        touched,
        isSubmitting,
      }: FormikProps<MyFormValues>) => (
        <>
          <Form
            name="contact"
            method="post"
            data-netlify-honeypot="bot-field"
            data-netlify="true"
            action="/thanks"
          >
            <Input type="hidden" name="form-name" value="contact" />

            <ContactWrapper>
              <ContactPageTitle>
                <h1>Contact</h1>
                
              </ContactPageTitle>
              <ContactFromWrapper>
                <InputGroup>
                  <Input
                    type="text"
                    name="firstName"
                    value={`${values.firstName}`}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    label="Name"
                    notification={`${
                      errors.firstName && touched.firstName
                        ? errors.firstName
                        : ""
                    }`}
                  />

                  <Input
                    type="email"
                    name="email"
                    value={`${values.email}`}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    label="Email"
                    notification={`${
                      errors.email && touched.email ? errors.email : ""
                    }`}
                  />
                </InputGroup>
                <Input
                  type="textarea"
                  name="message"
                  value={`${values.message}`}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  label="Message"
                  notification={
                    errors.message && touched.message ? errors.message : ""
                  }
                />
                <Button
                  title="Submit"
                  type="submit"
                  isLoading={isSubmitting ? true : false}
                  loader="Submitting.."
                />
              </ContactFromWrapper>
            </ContactWrapper>
          </Form>
        </>
      )}
    />
  )
}

export default Contact
